import { connect, type MapStateToProps, type MapDispatchToProps } from 'react-redux';

import { showError } from '../../state/actions';
import { getOrigin } from '../../state/context/selectors';
import { type State } from '../../state/types';
import {
	getConfluenceLicenseStatus,
	getIsPostExpand,
	isSpaceHomePageNull,
	isPageHomePageNull,
} from '../../state/ui/selectors';
import {
	getBlueprints,
	getProjectPageLinkedId,
	getProjectSpaceKey,
} from '../../state/confluence/connected-space/selectors';
import { getIsProjectPagesSporkRebrandingEnabled } from '../../state/feature-flags/selectors';

import TemplatesPanelContainer from './index';
import { type StateProps, type OwnProps, type DispatchProps } from './types';
import { getAccessRequestCapability } from '../../state/confluence/access-request-capabilities/selectors';
import { areTemplatesEnabled } from '../../state/ui/blueprints/selectors';
import { isConfluenceAutoProvisioned } from '../../state/personalization/selectors';
import { getProjectId, getProjectType } from '../../state/project/selectors';

const mapStateToProps: MapStateToProps<StateProps, OwnProps, State> = (
	state: State,
	{ hasConfluence }: OwnProps,
): StateProps => ({
	accessRequestCapability: getAccessRequestCapability(state),
	areTemplatesEnabled:
		areTemplatesEnabled(state) && !(isSpaceHomePageNull(state) || isPageHomePageNull(state)),
	blueprints: getBlueprints(state),
	isProjectPagesSporkRebrandingEnabled: getIsProjectPagesSporkRebrandingEnabled(state),
	isConfluenceAutoProvisioned: isConfluenceAutoProvisioned(state),
	confluenceLicenseStatus: getConfluenceLicenseStatus(state),
	hasAccessToConfluence: getIsPostExpand(state, hasConfluence),
	origin: getOrigin(state),
	contentId: getProjectPageLinkedId(state),
	spaceKey: getProjectSpaceKey(state),
	projectId: getProjectId(state),
	projectType: getProjectType(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (dispatch) => ({
	showError: () => dispatch(showError()),
});

export default connect<StateProps, DispatchProps, OwnProps, State>(
	mapStateToProps,
	mapDispatchToProps,
)(TemplatesPanelContainer);
